import { Card } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'

import styles from './index.module.css'

type ConfirmedInsuranceCoverageSuccessProps = {
  benefitEligibilityDate: string
}

const ConfirmedInsuranceCoverageSuccess = ({ benefitEligibilityDate }: ConfirmedInsuranceCoverageSuccessProps) => {
  return (
    <Card className={styles.wrap}>
      <div className={styles.iconSuccess}>
        <i className="fas fa-check-circle"></i>
      </div>

      <h3>
        <b>Success</b>
      </h3>

      <p className={styles.paragraph}>
        You’ve confirmed your annual insurance coverage for ICHRA. Check back on{' '}
        {parseZoneFormat(benefitEligibilityDate)} to mark your ongoing coverage.
      </p>
    </Card>
  )
}

export default ConfirmedInsuranceCoverageSuccess
